export const printCageCards = (...args: Parameters<typeof import("./printCageCards").printCageCards>) =>
    import("./printCageCards").then((module) => module.printCageCards(...args));

export const showAddBirth = (...args: Parameters<typeof import("./addBirth").showAddBirth>) =>
    import("./addBirth").then((module) => module.showAddBirth(...args));

export const showAnimalExportQuickselect = (
    ...args: Parameters<typeof import("./animalExportQuickselect").showAnimalExportQuickselect>
) => import("./animalExportQuickselect").then((module) => module.showAnimalExportQuickselect(...args));

export const showAnimalQuickselect = (
    ...args: Parameters<typeof import("./animalQuickselect").showAnimalQuickselect>
) => import("./animalQuickselect").then((module) => module.showAnimalQuickselect(...args));

export const showAnimalDetails = (...args: Parameters<typeof import("./animalDetails").showAnimalDetails>) =>
    import("./animalDetails").then((module) => module.showAnimalDetails(...args));

export const showAnimalPedigree = (...args: Parameters<typeof import("./animalPupPedigree").showAnimalPedigree>) =>
    import("./animalPupPedigree").then((module) => module.showAnimalPedigree(...args));

export const showAnnouncementDetails = (
    ...args: Parameters<typeof import("./announcementDetails").showAnnouncementDetails>
) => import("./announcementDetails").then((module) => module.showAnnouncementDetails(...args));

export const showBlockStrainDialog = (...args: Parameters<typeof import("./blockStrain").showBlockStrainDialog>) =>
    import("./blockStrain").then((module) => module.showBlockStrainDialog(...args));

export const showBreedingPerformanceDetails = (
    ...args: Parameters<typeof import("./breedingPerformanceDetails").showBreedingPerformanceDetails>
) => import("./breedingPerformanceDetails").then((module) => module.showBreedingPerformanceDetails(...args));

export const showCageDetails = (...args: Parameters<typeof import("./cageDetails").showCageDetails>) =>
    import("./cageDetails").then((module) => module.showCageDetails(...args));

export const showCageQuickselect = (...args: Parameters<typeof import("./cageQuickselect").showCageQuickselect>) =>
    import("./cageQuickselect").then((module) => module.showCageQuickselect(...args));

export const showComments = (...args: Parameters<typeof import("./comments").showComments>) =>
    import("./comments").then((module) => module.showComments(...args));

export const showCompetenceDetails = (
    ...args: Parameters<typeof import("./competenceDetails").showCompetenceDetails>
) => import("./competenceDetails").then((module) => module.showCompetenceDetails(...args));

export const showCryotankBrowser = (...args: Parameters<typeof import("./cryotankBrowser").showCryotankBrowser>) =>
    import("./cryotankBrowser").then((module) => module.showCryotankBrowser(...args));

export const showCryotankDetails = (...args: Parameters<typeof import("./cryotankDetails").showCryotankDetails>) =>
    import("./cryotankDetails").then((module) => module.showCryotankDetails(...args));

export const showDeviceDetails = (...args: Parameters<typeof import("./deviceDetails").showDeviceDetails>) =>
    import("./deviceDetails").then((module) => module.showDeviceDetails(...args));

export const showDeviceEventDetails = (
    ...args: Parameters<typeof import("./deviceEventDetails").showDeviceEventDetails>
) => import("./deviceEventDetails").then((module) => module.showDeviceEventDetails(...args));

export const showDrugDetails = (...args: Parameters<typeof import("./drugDetails").showDrugDetails>) =>
    import("./drugDetails").then((module) => module.showDrugDetails(...args));

export const showDrugPackageDetails = (
    ...args: Parameters<typeof import("./drugPackageDetails").showDrugPackageDetails>
) => import("./drugPackageDetails").then((module) => module.showDrugPackageDetails(...args));

export const showDrugPackageQuickselect = (
    ...args: Parameters<typeof import("./drugPackageQuickselect").showDrugPackageQuickselect>
) => import("./drugPackageQuickselect").then((module) => module.showDrugPackageQuickselect(...args));

export const showDrugRegisterDetails = (
    ...args: Parameters<typeof import("./drugRegisterDetails").showDrugRegisterDetails>
) => import("./drugRegisterDetails").then((module) => module.showDrugRegisterDetails(...args));

export const showDrugRequestDetails = (
    ...args: Parameters<typeof import("./drugRequestDetails").showDrugRequestDetails>
) => import("./drugRequestDetails").then((module) => module.showDrugRequestDetails(...args));

export const showEmbryoDetails = (...args: Parameters<typeof import("./embryoDetails").showEmbryoDetails>) =>
    import("./embryoDetails").then((module) => module.showEmbryoDetails(...args));

export const showEmbryoImport = (...args: Parameters<typeof import("./embryoImport").showEmbryoImport>) =>
    import("./embryoImport").then((module) => module.showEmbryoImport(...args));

export const showEmbryoQuickselect = (
    ...args: Parameters<typeof import("./embryoQuickselect").showEmbryoQuickselect>
) => import("./embryoQuickselect").then((module) => module.showEmbryoQuickselect(...args));

export const showCreateInvoiceBatchDialog = (
    ...args: Parameters<typeof import("./invoiceBatch").showCreateInvoiceBatchDialog>
) => import("./invoiceBatch").then((module) => module.showCreateInvoiceBatchDialog(...args));

export const showApplyInvoiceDiscountDialog = (
    ...args: Parameters<typeof import("./invoiceBatch").showApplyInvoiceDiscountDialog>
) => import("./invoiceBatch").then((module) => module.showApplyInvoiceDiscountDialog(...args));

export const showIndependentDocumentDetails = (
    ...args: Parameters<typeof import("./independentDocumentDetails").showIndependentDocumentDetails>
) => import("./independentDocumentDetails").then((module) => module.showIndependentDocumentDetails(...args));

export const showLicenseDetails = (...args: Parameters<typeof import("./licenseDetails").showLicenseDetails>) =>
    import("./licenseDetails").then((module) => module.showLicenseDetails(...args));

export const showLicenseSignOff = (...args: Parameters<typeof import("./licenseSignOff").showLicenseSignOff>) =>
    import("./licenseSignOff").then((module) => module.showLicenseSignOff(...args));

export const showLitterActions = (...args: Parameters<typeof import("./litterActions").showLitterActions>) =>
    import("./litterActions").then((module) => module.showLitterActions(...args));

export const showMicrowellPlateDetails = (
    ...args: Parameters<typeof import("./microwellPlateDetails").showMicrowellPlateDetails>
) => import("./microwellPlateDetails").then((module) => module.showMicrowellPlateDetails(...args));

export const showMicrowellPlateExport = (
    ...args: Parameters<typeof import("./microwellPlateExport").showMicrowellPlateExport>
) => import("./microwellPlateExport").then((module) => module.showMicrowellPlateExport(...args));

export const showMicrowellPlatePositionPicker = (
    ...args: Parameters<typeof import("./microwellPlatePicker").showMicrowellPlatePositionPicker>
) => import("./microwellPlatePicker").then((module) => module.showMicrowellPlatePositionPicker(...args));

export const showMutationDetails = (...args: Parameters<typeof import("./mutationDetails").showMutationDetails>) =>
    import("./mutationDetails").then((module) => module.showMutationDetails(...args));

export const showNewWorkRequest = (...args: Parameters<typeof import("./workRequestNew").showNewWorkRequest>) =>
    import("./workRequestNew").then((module) => module.showNewWorkRequest(...args));

export const showOrderRequestDetails = (
    ...args: Parameters<typeof import("./orderRequestDetails").showOrderRequestDetails>
) => import("./orderRequestDetails").then((module) => module.showOrderRequestDetails(...args));

export const showOrderRequestAnimalExport = (
    ...args: Parameters<typeof import("./orderRequestAnimalExport").showOrderRequestAnimalExport>
) => import("./orderRequestAnimalExport").then((module) => module.showOrderRequestAnimalExport(...args));

export const showOriginDetails = (...args: Parameters<typeof import("./originDetails").showOriginDetails>) =>
    import("./originDetails").then((module) => module.showOriginDetails(...args));

export const showProjectDetails = (...args: Parameters<typeof import("./projectDetails").showProjectDetails>) =>
    import("./projectDetails").then((module) => module.showProjectDetails(...args));

export const showPupDetails = (...args: Parameters<typeof import("./pupDetails").showPupDetails>) =>
    import("./pupDetails").then((module) => module.showPupDetails(...args));

export const showPupPedigree = (...args: Parameters<typeof import("./animalPupPedigree").showPupPedigree>) =>
    import("./animalPupPedigree").then((module) => module.showPupPedigree(...args));

export const showScheduledReportDetails = (
    ...args: Parameters<typeof import("./scheduledReportDetails").showScheduledReportDetails>
) => import("./scheduledReportDetails").then((module) => module.showScheduledReportDetails(...args));

export const showServiceDetails = (...args: Parameters<typeof import("./serviceDetails").showServiceDetails>) =>
    import("./serviceDetails").then((module) => module.showServiceDetails(...args));

export const showServiceRequestDetails = (
    ...args: Parameters<typeof import("./serviceRequestDetails").showServiceRequestDetails>
) => import("./serviceRequestDetails").then((module) => module.showServiceRequestDetails(...args));

export const showSetAnimalOwner = (...args: Parameters<typeof import("./setAnimalOwner").showSetAnimalOwner>) =>
    import("./setAnimalOwner").then((module) => module.showSetAnimalOwner(...args));

export const showSetAnimalResponsible = (
    ...args: Parameters<typeof import("./setAnimalResponsible").showSetAnimalResponsible>
) => import("./setAnimalResponsible").then((module) => module.showSetAnimalResponsible(...args));

export const showSetBirthComment = (...args: Parameters<typeof import("./setBirthComment").showSetBirthComment>) =>
    import("./setBirthComment").then((module) => module.showSetBirthComment(...args));

export const showSetBirthNumbers = (...args: Parameters<typeof import("./setBirthNumbers").showSetBirthNumbers>) =>
    import("./setBirthNumbers").then((module) => module.showSetBirthNumbers(...args));

export const showSetCageCategory = (...args: Parameters<typeof import("./setCageCategory").showSetCageCategory>) =>
    import("./setCageCategory").then((module) => module.showSetCageCategory(...args));

export const showSetCageLabel = (...args: Parameters<typeof import("./setCageLabel").showSetCageLabel>) =>
    import("./setCageLabel").then((module) => module.showSetCageLabel(...args));

export const showSetCageLocation = (...args: Parameters<typeof import("./setCageLocation").showSetCageLocation>) =>
    import("./setCageLocation").then((module) => module.showSetCageLocation(...args));

export const showSetCageNumber = (...args: Parameters<typeof import("./setCageNumber").showSetCageNumber>) =>
    import("./setCageNumber").then((module) => module.showSetCageNumber(...args));

export const showSetCageOwner = (...args: Parameters<typeof import("./setCageOwner").showSetCageOwner>) =>
    import("./setCageOwner").then((module) => module.showSetCageOwner(...args));

export const showSetCagePosition = (...args: Parameters<typeof import("./setCagePosition").showSetCagePosition>) =>
    import("./setCagePosition").then((module) => module.showSetCagePosition(...args));

export const showSetCageResponsible = (
    ...args: Parameters<typeof import("./setCageResponsible").showSetCageResponsible>
) => import("./setCageResponsible").then((module) => module.showSetCageResponsible(...args));

export const showSetCohortId = (...args: Parameters<typeof import("./setCohortId").showSetCohortId>) =>
    import("./setCohortId").then((module) => module.showSetCohortId(...args));

export const showSetEartag = (...args: Parameters<typeof import("./setEartag").showSetEartag>) =>
    import("./setEartag").then((module) => module.showSetEartag(...args));

export const showSetGeneration = (...args: Parameters<typeof import("./setGeneration").showSetGeneration>) =>
    import("./setGeneration").then((module) => module.showSetGeneration(...args));

export const showSetGeneticBackground = (
    ...args: Parameters<typeof import("./setGeneticBackground").showSetGeneticBackground>
) => import("./setGeneticBackground").then((module) => module.showSetGeneticBackground(...args));

export const showSetLabId = (...args: Parameters<typeof import("./setLabId").showSetLabId>) =>
    import("./setLabId").then((module) => module.showSetLabId(...args));

export const showSetLicense = (...args: Parameters<typeof import("./setLicense").showSetLicense>) =>
    import("./setLicense").then((module) => module.showSetLicense(...args));

export const showSetMedicalConditions = (
    ...args: Parameters<typeof import("./setMedicalConditions").showSetMedicalConditions>
) => import("./setMedicalConditions").then((module) => module.showSetMedicalConditions(...args));

export const showSetMutation = (...args: Parameters<typeof import("./setMutation").showSetMutation>) =>
    import("./setMutation").then((module) => module.showSetMutation(...args));

export const showSetNumberOfTankAnimals = (
    ...args: Parameters<typeof import("./setNumberOfTankAnimals").showSetNumberOfTankAnimals>
) => import("./setNumberOfTankAnimals").then((module) => module.showSetNumberOfTankAnimals(...args));

export const showSetPlugDate = (...args: Parameters<typeof import("./setPlugDate").showSetPlugDate>) =>
    import("./setPlugDate").then((module) => module.showSetPlugDate(...args));

export const showSetProjects = (...args: Parameters<typeof import("./setProjects").showSetProjects>) =>
    import("./setProjects").then((module) => module.showSetProjects(...args));

export const showSetRFID = (...args: Parameters<typeof import("./setRFID").showSetRFID>) =>
    import("./setRFID").then((module) => module.showSetRFID(...args));

export const showSetSacrificeMessages = (
    ...args: Parameters<typeof import("./setSacrificeMessages").showSetSacrificeMessages>
) => import("./setSacrificeMessages").then((module) => module.showSetSacrificeMessages(...args));

export const showSetSexMoveSacrifice = (
    ...args: Parameters<typeof import("./setSexMoveSacrifice").showSetSexMoveSacrifice>
) => import("./setSexMoveSacrifice").then((module) => module.showSetSexMoveSacrifice(...args));

export const showSpeciesDetails = (...args: Parameters<typeof import("./speciesDetails").showSpeciesDetails>) =>
    import("./speciesDetails").then((module) => module.showSpeciesDetails(...args));

export const showSetSpecies = (...args: Parameters<typeof import("./setSpecies").showSetSpecies>) =>
    import("./setSpecies").then((module) => module.showSetSpecies(...args));

export const showSetStrain = (...args: Parameters<typeof import("./setStrain").showSetStrain>) =>
    import("./setStrain").then((module) => module.showSetStrain(...args));

export const showSetStrawLabel = (...args: Parameters<typeof import("./setStrawLabel").showSetStrawLabel>) =>
    import("./setStrawLabel").then((module) => module.showSetStrawLabel(...args));

export const showSetStudStatus = (...args: Parameters<typeof import("./setStudStatus").showSetStudStatus>) =>
    import("./setStudStatus").then((module) => module.showSetStudStatus(...args));

export const showSetTankAgeLevel = (...args: Parameters<typeof import("./setTankAgeLevel").showSetTankAgeLevel>) =>
    import("./setTankAgeLevel").then((module) => module.showSetTankAgeLevel(...args));

export const showSetTankLabel = (...args: Parameters<typeof import("./setTankLabel").showSetTankLabel>) =>
    import("./setTankLabel").then((module) => module.showSetTankLabel(...args));

export const showSetTankLocationLabel = (
    ...args: Parameters<typeof import("./setTankLocationLabel").showSetTankLocationLabel>
) => import("./setTankLocationLabel").then((module) => module.showSetTankLocationLabel(...args));

export const showSetUserStatus = (...args: Parameters<typeof import("./setUserStatus").showSetUserStatus>) =>
    import("./setUserStatus").then((module) => module.showSetUserStatus(...args));

export const showSetWeight = (...args: Parameters<typeof import("./setWeight").showSetWeight>) =>
    import("./setWeight").then((module) => module.showSetWeight(...args));

export const showSetWorkRequestClass = (
    ...args: Parameters<typeof import("./setWorkRequestClass").showSetWorkRequestClass>
) => import("./setWorkRequestClass").then((module) => module.showSetWorkRequestClass(...args));

export const showSetWorkRequestLocation = (
    ...args: Parameters<typeof import("./setWorkRequestLocation").showSetWorkRequestLocation>
) => import("./setWorkRequestLocation").then((module) => module.showSetWorkRequestLocation(...args));

export const showSetWorkRequestPriority = (
    ...args: Parameters<typeof import("./setWorkRequestPriority").showSetWorkRequestPriority>
) => import("./setWorkRequestPriority").then((module) => module.showSetWorkRequestPriority(...args));

export const showSetWorkRequestResponsible = (
    ...args: Parameters<typeof import("./setWorkRequestResponsible").showSetWorkRequestResponsible>
) => import("./setWorkRequestResponsible").then((module) => module.showSetWorkRequestResponsible(...args));

export const showSetWorkRequestStatus = (
    ...args: Parameters<typeof import("./setWorkRequestStatus").showSetWorkRequestStatus>
) => import("./setWorkRequestStatus").then((module) => module.showSetWorkRequestStatus(...args));

export const showSeverityLevelDetails = (
    ...args: Parameters<typeof import("./severityLevelDetails").showSeverityLevelDetails>
) => import("./severityLevelDetails").then((module) => module.showSeverityLevelDetails(...args));

export const showSeverityAssessmentSheet = (
    ...args: Parameters<typeof import("./severityAssessmentSheet").showSeverityAssessmentSheet>
) => import("./severityAssessmentSheet").then((module) => module.showSeverityAssessmentSheet(...args));

export const showSeverityAssessmentTemplate = (
    ...args: Parameters<typeof import("./severityAssessmentTemplate").showSeverityAssessmentTemplate>
) => import("./severityAssessmentTemplate").then((module) => module.showSeverityAssessmentTemplate(...args));

export const showSpermDetails = (...args: Parameters<typeof import("./spermDetails").showSpermDetails>) =>
    import("./spermDetails").then((module) => module.showSpermDetails(...args));

export const showSpermImport = (...args: Parameters<typeof import("./spermImport").showSpermImport>) =>
    import("./spermImport").then((module) => module.showSpermImport(...args));

export const showSpermQuickselect = (...args: Parameters<typeof import("./spermQuickselect").showSpermQuickselect>) =>
    import("./spermQuickselect").then((module) => module.showSpermQuickselect(...args));

export const showStudQuickselect = (...args: Parameters<typeof import("./studQuickselect").showStudQuickselect>) =>
    import("./studQuickselect").then((module) => module.showStudQuickselect(...args));

export const showTankAnimalImport = (...args: Parameters<typeof import("./tankAnimalImport").showTankAnimalImport>) =>
    import("./tankAnimalImport").then((module) => module.showTankAnimalImport(...args));

export const showTankCrossingDetails = (
    ...args: Parameters<typeof import("./tankCrossingDetails").showTankCrossingDetails>
) => import("./tankCrossingDetails").then((module) => module.showTankCrossingDetails(...args));

export const showTankDetails = (...args: Parameters<typeof import("./tankDetails").showTankDetails>) =>
    import("./tankDetails").then((module) => module.showTankDetails(...args));

export const showTankQuickselect = (...args: Parameters<typeof import("./tankQuickselect").showTankQuickselect>) =>
    import("./tankQuickselect").then((module) => module.showTankQuickselect(...args));

export const showUserCertificateDetails = (
    ...args: Parameters<typeof import("./userCertificateDetails").showUserCertificateDetails>
) => import("./userCertificateDetails").then((module) => module.showUserCertificateDetails(...args));

export const showCreateUser = (...args: Parameters<typeof import("./userDetails").showCreateUser>) =>
    import("./userDetails").then((module) => module.showCreateUser(...args));

export const showUserDetails = (...args: Parameters<typeof import("./userDetails").showUserDetails>) =>
    import("./userDetails").then((module) => module.showUserDetails(...args));

export const showWorkRequestClassDetails = (
    ...args: Parameters<typeof import("./workRequestClassDetails").showWorkRequestClassDetails>
) => import("./workRequestClassDetails").then((module) => module.showWorkRequestClassDetails(...args));

export const showWorkRequestDetails = (
    ...args: Parameters<typeof import("./workRequestDetails").showWorkRequestDetails>
) => import("./workRequestDetails").then((module) => module.showWorkRequestDetails(...args));

export const showStrainDetails = (...args: Parameters<typeof import("./strainDetails").showStrainDetails>) =>
    import("./strainDetails").then((module) => module.showStrainDetails(...args));

export const showStrainDatabaseValues = (
    ...args: Parameters<typeof import("./strainDatabaseValues").showStrainDatabaseValues>
) => import("./strainDatabaseValues").then((module) => module.showStrainDatabaseValues(...args));

export const showStrainDatabaseFieldValues = (
    ...args: Parameters<typeof import("./strainDatabaseFieldValues").showStrainDatabaseFieldValues>
) => import("./strainDatabaseFieldValues").then((module) => module.showStrainDatabaseFieldValues(...args));

export const showSetCageAlarm = (...args: Parameters<typeof import("./setCageAlarm").showSetCageAlarm>) =>
    import("./setCageAlarm").then((module) => module.showSetCageAlarm(...args));
